export const SLIDER_SWIPE_UPDATE = 'SLIDER:SWIPE:UPDATE';
export const SLIDER_SWIPE_RESET_TO_DEFAULT = 'SLIDER:SWIPE:RESET_TO_DEFAULT';

export const resetToDefault = () => ({
    type: SLIDER_SWIPE_RESET_TO_DEFAULT
});

export const updateData = (data) => ({
    type: SLIDER_SWIPE_UPDATE,
    payload: data,
    isSilent: true
});
